<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Create an Account</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div fxLayout="row" fxLayoutGap="30px">
    <div fxFlex="grow">
      <div [innerHtml]="instruction" class="ul"></div>
      <div class="ui light padded box segment no-border">
        <div>
          By clicking <strong>Proceed</strong> you agree to our
          <u
            ><a routerLink="/home-page/terms-and-conditions"
              >Terms of Service</a
            ></u
          >
          and
          <u
            ><a routerLink="/home-page/terms-and-conditions"
              >Privacy Policy</a
            ></u
          >
          and that your continued use of the website is subject to these
          policies.
        </div>
      </div>

      <div
        class="ui segment box"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        id="section"
        routerLink="/home-page/sign-up/step2"
      >
        <div fxFlex>
          <!-- <i class="arrow right  colored primary icon"></i> -->
        </div>
        <div>
          <button class="ui primary button">Proceed</button>
        </div>
      </div>
    </div>

    <div
      fxFlex="30%"
      fxHide.lt-sm="true"
      appPadding
      paddingT="0"
      fxLayout="column"
      class="ui vertical basic segment"
      [ngClass]="{ loading: mpending }"
    >
      <div class="side" appPadding="7">
        <div [innerHtml]="registrationSidebar"></div>
      </div>
    </div>
  </div>
</div>
